import { z } from "zod";

export const state = z.enum([
  "START",
  "ORDER_SUMMARY",
  "ORDER_FULFILLMENT",
  "ORDER_PENDING_CANCELLATION",
  "ORDER_COMMITTED",
  "COMPLETED",
  "DELIVERY",
  "SIM",
]);

const deliveryMethodId = z.enum(["COURIER", "ESIM"]).optional();

const shippingStatus = z.enum([
  "PACK_CHAN",
  "DELV_PROGR_CHAN",
  "DELV_CHAN",
  "RET_PROGR_CHAN",
  "RET_CHAN",
  "AGGR_CHAN2",
  "AGGR_CHAN3",
  "ACC_CHAN",
  "CANC_CHAN",
]);

const delivery = z.object({
  country: z.string().optional(),
  street: z.string().optional(),
  streetNumber: z.string(),
  apartmentNumber: z.string().optional(),
  municipality: z.string(),
  postCode: z.string(),
  note: z.string().optional(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  contactNumber: z.string().optional(),
});

export const changeSimEsimOrchestrator = z.object({
  type: z.literal("NJU_SIM_MANAGEMENT"),
  state,
  id: z.string(),
  orderId: z.string().optional(),
  delivery: delivery.optional(),
  orderSimNumber: z.string().optional(),
  deliveryMethodId,
  shippingStatus: shippingStatus.optional(),
  orderModifiedAt: z.string().optional(),
});

export type IChangeSimEsimOrchestrator = z.infer<
  typeof changeSimEsimOrchestrator
>;
